<ul class="list-unstyled">
    @for (question of questions; track question; let i = $index) {
        <li>
            <div>{{ question.text }}</div>
            <div
                [class.correct-answer]="isCorrect(question, answers[i])"
                [class.wrong-answer]="!isCorrect(question, answers[i])">
                @if (isCorrect(question, answers[i])) {
                    <span><i class="far fa-check me-1"></i></span>
                }
                @if (!isCorrect(question, answers[i])) {
                    <span><i class="far fa-times me-1"></i></span>
                }
                <strong>Jouw antwoord:</strong>
                {{ getChosenAnswerText(question, answers[i]) }}
            </div>
            @if (!isCorrect(question, answers[i])) {
                <div class="correct-answer mt-1">
                    <strong>Het juiste antwoord was:</strong>
                    {{ getCorrectAnswerText(question) }}
                </div>
            }
            <hr />
        </li>
    }
</ul>
